import Input from "../../components/common/input";
import React, {useState} from "react";
import Selector from "../../components/common/selector";
import UserForm from "../../components/userForm";
import PropTypes from "prop-types";
import {PROGRAM_ASSOCIATION_LABEL} from "../../constants";
import {clearChangePasswordErrors} from "../../actions/users";
import {Link} from "react-router-dom";
import {useDispatch} from "react-redux";
import {userCanAccess} from "../../utils/users";

const PERMISSIONS = [
  {
    label: '',
    value: ''
  },
  {
    label: 'Counselor',
    value: 'Counselor'
  },
  {
    label: 'Teacher',
    value: 'Teacher'
  },
  {
    label: 'School Administrator',
    value: 'School Administrator'
  },
  {
    label: 'District Administrator',
    value: 'District Administrator'
  },
  {
    label: 'Academic Prep Partner',
    value: 'Academic Prep Partner'
  },
  {
    label: 'Registrar',
    value: 'Registrar'
  },
  {
    label: 'Other',
    value: 'Other'
  }
];

const EditProfile = (props) => {
  const {
    errors,
    myProfile,
    onSubmitAction,
    onCancelAction,
  } = props;

  const dispatch = useDispatch();

  const [email, setEmail] = useState(myProfile.user.username);
  const [firstName, setFirstName] = useState(myProfile.user.firstName);
  const [lastName, setLastName] = useState(myProfile.user.lastName);
  const [role, setRole] = useState((myProfile.userRole) ? myProfile.userRole.id : '');
  const [programAssociation, setProgramAssociation] = useState((myProfile.program) ? myProfile.program.id : '');

  let roles = [];

  if (myProfile && myProfile.userRoleList) {
     roles = myProfile.userRoleList.map((element) => {
      return {
        label: element.name,
        value: element.id
      }
    });
  }

  roles.unshift(
    {
      label: '',
      value: ''
    }
  );

  let programs = [];

  if (myProfile && myProfile.programList) {
    programs = myProfile.programList.map((element) => {
      return {
        label: element.name,
        value: element.id
      }
    });
  }

  programs.unshift(
    {
      label: '',
      value: ''
    }
  )

  const handleKeyDown = (event) => {
    if(event.key === 'Enter'){
      submitAction(event.target.value);
    }
  }

  const submitAction = () => {
    onSubmitAction(
      {
        email: email,
        firstName: firstName,
        lastName: lastName,
        role: role,
        programAssociation: programAssociation
      },
      myProfile
    )
  };

  return (
    <UserForm formTitle='My Info' submitAction={submitAction} cancelAction={onCancelAction} submitLabel='Save' disabled={false}>
      <div className='form-required'>
        * Indicates Required Fields
      </div>
      <Input
        name='email'
        id='email'
        value={email}
        label='Email*'
        type='text'
        disabled={true}
        autoComplete='email'
        changeAction={setEmail}
      />
      <Input
        name='firstName'
        id='firstName'
        value={firstName}
        label='First Name*'
        type='text'
        onKeyDown={handleKeyDown}
        autoComplete='given-name'
        changeAction={setFirstName}
        errors={errors?.firstName}
      />
      <Input
        name='lastName'
        id='lastName'
        value={lastName}
        label='Last Name*'
        type='text'
        onKeyDown={handleKeyDown}
        autoComplete='family-name'
        changeAction={setLastName}
        errors={errors?.lastName}
      />
      <Selector
        name="role"
        label='Role'
        hide={true}
        value={role}
        changeAction={setRole}
        onKeyDown={handleKeyDown}
        showLabel={true}
        items={roles}
      />
      <Selector
        name="programAssociation"
        id='programAssociation'
        label={PROGRAM_ASSOCIATION_LABEL}
        hide={true}
        value={programAssociation}
        changeAction={setProgramAssociation}
        onKeyDown={handleKeyDown}
        showLabel={true}
        items={programs}
      />
      <div className='change-password-link'>
        {userCanAccess(myProfile, 'change-password') && <Link to='/change-password' onClick={() => dispatch(clearChangePasswordErrors())}>Change Password</Link>}
      </div>
    </UserForm>
  );
}

EditProfile.propTypes = {
  errors: PropTypes.object,
  myProfile: PropTypes.object.isRequired,
  onSubmitAction: PropTypes.func.isRequired,
  onCancelAction: PropTypes.func.isRequired
}

export default EditProfile;